import { DealDetailItem, DealDetailSearchPreview, DealErrorType } from '@/features/deals/types/dealDetails';

export const DEAL_DETAIL_ACTION = {
  SET_FETCHING: 'dealDetail/SET_FETCHING',
  SET_DATA: 'dealDetail/SET_DATA',
  SET_ERROR: 'dealDetail/SET_ERROR',
  SET_RESET: 'dealDetail/SET_RESET',
} as const;

export type DealDetailState = {
  data: {
    deal: DealDetailItem | null;
    searchPreview: DealDetailSearchPreview;
  };
  fetching: boolean;
  isSSRFetched: boolean;
  errorType: DealErrorType | null;
};

type DealDetailAction =
  | { type: typeof DEAL_DETAIL_ACTION.SET_FETCHING }
  | {
      type: typeof DEAL_DETAIL_ACTION.SET_DATA;
      payload: { deal: DealDetailItem | null; searchPreview: DealDetailSearchPreview };
    }
  | {
      type: typeof DEAL_DETAIL_ACTION.SET_ERROR;
      payload: { errorType: DealErrorType; deal: DealDetailItem | null; searchPreview: DealDetailSearchPreview };
    }
  | { type: typeof DEAL_DETAIL_ACTION.SET_RESET };

const initialState: DealDetailState = {
  data: {
    deal: null,
    searchPreview: [],
  },
  fetching: false,
  isSSRFetched: false,
  errorType: null,
};

export function dealDetail(state: DealDetailState = initialState, action: DealDetailAction): DealDetailState {
  switch (action.type) {
    case DEAL_DETAIL_ACTION.SET_FETCHING:
      return { ...state, fetching: true };
    case DEAL_DETAIL_ACTION.SET_DATA:
      return { data: action.payload, fetching: false, errorType: null, isSSRFetched: false };
    case DEAL_DETAIL_ACTION.SET_ERROR:
      return {
        data: { deal: action.payload.deal, searchPreview: action.payload.searchPreview },
        fetching: false,
        errorType: action.payload.errorType,
        isSSRFetched: false,
      };
    case DEAL_DETAIL_ACTION.SET_RESET:
      return initialState;
    default:
      return state;
  }
}
